import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';

export default withStyles({
  root: {
    fontSize: '0.9rem',
  },
})(MenuItem);
